export default __webpack_public_path__ + "static/contact-bg-9171e9952993f2859eb0f9e8f0c790bf.jpg";